import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const state = {
	userName: '',
	token: '',
	token_time: '',
	user_id: '',
	userType: '',
	isRuHui: '',
	hasQiYe: '',
	isShenHe: '',
}

const mutations = {
	updateToken (state, payload) {
		state.token = payload.token
		state.token_time = payload.token_time
	},
	updateUser (state, payload) {
		state.user_id = payload.user_id
		state.userName = payload.userName
		state.token = payload.token
		state.token_time = payload.token_time
	},
	// 留着
	updateUserType (state, payload) {
		state.userType = payload.userType
	},
	// 留着
	updateIsRuHui (state, payload) {
		state.isRuHui = payload.isRuHui
	},
	// 留着
	updateIsShenHe (state, payload) {
		state.isShenHe = payload.isShenHe
	},
	// 留着
	updateHasQiYe (state, payload) {
		state.hasQiYe = payload.hasQiYe
	},
	updateAll (state, payload) {
		state.userType = payload.userType
		state.isRuHui = payload.isRuHui
		state.isShenHe = payload.isShenHe
		state.hasQiYe = payload.hasQiYe
		state.token = payload.token
		state.token_time = payload.token_time
		state.user_id = payload.user_id
		state.userName = payload.userName
	}
}

export default new Vuex.Store({
	state,
	mutations,
})


// WEBPACK FOOTER //
// ./src/vuex/store.js